export const thingNames: Record<string, string> = {
	tname_AlbinoSquid: "Albino Squid",
	tname_AlbinoSquidCorpse: "Albino Squid corpse",
	tname_ArrowMob: "Arrow Monster",
	tname_ArtilleryBomb: "Artillery bomb",
	tname_ArtilleryRobot: "Artillery Robot",
	tname_Ashes: "",
	tname_Barrier: "Barrier",
	tname_BlackBox: "",
	tname_BigContainer: "Large crate",
	tname_BigSquid: "Squid Matriarch",
	tname_BigSquidCorpse: "Squid Matriarch corpse",
	tname_BigSquidTentacle: "Squid Matriarch",
	tname_BigSquidTentacleCorpse: "Squid Matriarch severed tentacle",
	tname_BigSquidTentacleCut: "Squid Matriarch",
	tname_Biter: "Biter",
	tname_BiterCorpse: "Biter corpse",
	tname_BlackFloor: "",
	tname_BlastDoor: "Blast Door",
	tname_SlidingDoor: "Sliding Door",
	tname_SlidingGate: "Sliding Gate",
	tname_BloodPool: "Blood",
	tname_CannonBullet: "Bomb",
	tname_BoxFloor: "",
	tname_BrickWall: "Brick wall",
	tname_BrownFloor: "",
	tname_SolidifierShot: "Bubble",
	tname_AirBlastShot: "Air blast",
	tname_SolidifiedBiter: "Solidified biter",
	tname_SolidifiedHorned: "Solidified horned monster",
	tname_SolidifiedSlugant: "Solidified slugant",
	tname_SolidifiedSquid: "Solidified squid",
	tname_CryoShot: "Cryo shot",
	tname_CaveRock: "Rock",
	tname_CaveFloor: "",
	tname_CaveRobot: "Cave Robot",
	tname_CaveRobotCorpse: "Cave Robot scrap",
	tname_Chasm: "Chasm",
	tname_ConcreteBlock: "Concrete",
	tname_ConcreteFloor: "",
	tname_Rock: "Rock",
	tname_RockMobCave: "Cave",
	tname_DarkConcreteFloor: "",
	tname_DeadPlant: "Dead plant",
	tname_DeskWithComputer: "Office desk",
	tname_DeskWithMachine: "Machine",
	tname_DestroyedConcreteBlock: "Concrete debris",
	tname_DestroyedRock: "",
	tname_Downstairs: "Stairs down",
	tname_BlackHoleProjectile: "Black hole",
	tname_DrillBullet: "Drill",
	tname_MiningRobot: "Mining robot",
	tname_PlasmaBall: "Plasma ball",
	tname_EmptyBarrel: "Barrel",
	tname_Equation: "Equation",
	tname_ExplosiveBarrel: "Barrel with explosives",
	tname_Fence: "Fence",
	tname_FenceLight: "Fence",
	tname_Fire: "Fire",
	tname_FireTower: "Fire Tower",
	tname_FloatingRobot: "Floating Robot",
	tname_FloatingRobotCorpse: "Floating Robot scrap",
	tname_GasBomb: "Gas bomb",
	tname_Gas: "Gas",
	tname_BileGas: "Bile Gas",
	tname_GasBarrel: "Gas barrel",
	tname_GoldDrop: "Cash",
	tname_GrassTiledFloor: "",
	tname_GraySlab: "",
	tname_GrayStoneFloor1: "",
	tname_GrayStoneFloor2: "",
	tname_HomingMissile: "Homing missile",
	tname_InvulnerableBigContainer: "Large crate",
	tname_Horned: "Horned monster",
	tname_HornedCorpse: "Horned monster corpse",
	tname_KeyLootBox: "Key",
	tname_PowerPlantKeyCardLootBox: "Power plant key card",
	tname_BaseKeyCardLootBox: "Base key card",
	tname_NightVisionLootBox: "Night vision equipment",
	tname_JetpackLootBox: "Jetpack",
	tname_LadderDown: "Ladder down",
	tname_LadderUp: "Ladder up",
	tname_Lamp: "",
	tname_Landmine: "Landmine",
	tname_LavaPool: "Lava",
	tname_LevelDown: "Level exit to next location",
	tname_LevelUp: "Level exit to previous location",
	tname_LootBox: "Small crate",
	tname_MachineConnectedToWall: "Machine",
	tname_MachineRack: "Machine rack",
	tname_LargeMachine: "Large machine",
	tname_SlugantCorpse: "Slugant corpse",
	tname_Slugant: "Slugant",
	tname_ToxicSlug: "Toxic slug",
	tname_BilePuddle: "Bile puddle",
	tname_ToxicSlugBrokenShell: "Broken slug shell",
	tname_MedicalLootBox: "Medical kit",
	tname_MetalBlock: "Metal wall",
	tname_MetalBlockDiagonal: "Metal wall",
	tname_MetalDoor: "Metal door",
	tname_MetalGridFloor: "Metal grid floor",
	tname_MetalLootBox: "Crate of high quality items",
	tname_Missile: "Missile",
	tname_MossBrick: "Moss brick wall",
	tname_MossFloor: "",
	tname_MossGate: "Gate",
	tname_OfficeChair: "Office chair",
	tname_PlasticCabinet: "Plastic cabinet",
	tname_OpenBlastDoorsTerminal: "Terminal",
	tname_PowerPlantGateTerminal: "Terminal",
	tname_PowerPlantSwitch: "Power plant switch",
	tname_VendingMachine: "Vending machine",
	tname_Plant: "Vegetation",
	tname_Player: "You",
	tname_PlowRobot: "Plow Robot",
	tname_BossPlowRobot: "Plow Robot Boss",
	tname_BlackHoleRobot: "Black Hole Robot",
	tname_Portal2: "Monster portal",
	tname_Amoeba: "Amoeba",
	tname_AmoebaCorpse: "Amoeba corpse",
	tname_PottedPlant: "Plastic plant",
	tname_RareItemsLootBox: "Rare items crate",
	tname_ReinforcedPortal2: "Monster portal",
	tname_Robot: "Robot",
	tname_HeavyRobot: "Heavy Robot",
	tname_JetpackMob: "Jetpack Robot",
	tname_RobotCorpse: "Robot scrap",
	tname_EngineerRobot: "Engineer Robot",
	tname_EngineerCorpse: "Engineer Robot scrap",
	tname_DummyMob: "Dummy",
	tname_DummyMobB: "Dummy B",
	tname_DummyMobCorpse: "Dummy corpse",
	tname_RobotEntranceTerminal: "Terminal",
	tname_UnbreakableRock: "Rock",
	tname_RobotSpawner: "Robot elevator shaft",
	tname_ScrapMetal: "Scrap metal",
	tname_Sculpture1: "Sculpture",
	tname_ShortSolidifierShot: "Bubble",
	tname_Shrapnel: "Shrapnel",
	tname_Sign: "Sign",
	tname_Smoke: "Smoke",
	tname_SnakeBody: "Snake",
	tname_SnakeHead: "Snake",
	tname_Spreader: "Moss",
	tname_Squid: "Squid",
	tname_SquidCorpse: "Squid corpse",
	tname_Tomb: "Tombstone",
	tname_Tree: "Tree",
	tname_Upstairs: "Stairs up",
	tname_WallCrack: "",
	tname_WarningFloor: "",
	tname_WavyTile: "",
	tname_TornGround: "",
	tname_WaterTile: "Water",
	tname_WinConditionTerminal: "Terminal",
	tname_WoodenBridgeFloor: "",
	tname_WoodenCabinet: "Wooden cabinet",
	tname_WoodenDesk: "Wooden desk",
	tname_WoodenDoor: "Door",
	tname_WoodenFloor: "",
	tname_WoodenShelf: "Shelf",
	tname_ZooReleaseTerminal: "Terminal",
};
